import { StateObject } from '~src/domains/common/types/common';

export const fullSSNFormSelector = (state: StateObject) => state.fullSSNForm;
